const BASE_URL = process.env.REACT_APP_BASE_URL;
const IDPID = process.env.REACT_APP_IDPID;

export const getConfigurations = async () => {
    const url = `${BASE_URL}/config/configurations?idpid=${IDPID}`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error('Failed to get config');
    }
    return await response.json();
};